import React from 'react';
import Navbar from '../../../components/Navbar';
import { Loader } from '../../../components/Loader';
import EditRequestForm from '../../../components/RequestForms/EditRequestForm';
import { GET_REQUEST_BY_ID, requestedItemsByRequestId } from '../api';
import { useQuery } from '@apollo/client';
import { nextAndPreviousRequest, queryAppUsers } from '../../../components/RequestForms/api';
import { ErrorMessage } from '../../../components/ErrorMessage';

export const EditRequestPage = (props) => {
  const { loading, error, data } = useQuery(GET_REQUEST_BY_ID, {
    variables: { id: parseInt(props.match.params.requestId) },
  });

  const {
    loading: riLoading,
    error: riError,
    data: riData,
  } = useQuery(requestedItemsByRequestId, {
    variables: { id: parseInt(props.match.params.requestId) },
  });
  
  const {
    loading: auLoading,
    error: auError,
    data: auData,
  } = useQuery(queryAppUsers);

  const {
    data: npData,
    loading: npLoading,
    error: npError,
  } = useQuery(nextAndPreviousRequest, {
    variables: {
      requestId: parseInt(props.match.params.requestId),
    },
  });

  if (loading || riLoading || auLoading || npLoading) {
    return (
      <div>
        <Navbar />
        <Loader />
      </div>
    );
  }

  if (error || riError || auError || npError)
    return (
      <>
        <Navbar />
        <ErrorMessage title='Whoops! Error at /src/pages/Receiving/EditRequest' />
      </>
    );
  if (data && riData && auData && npData) {
    return (
      <div>
        <Navbar />
        <div className='m-4'>
          <EditRequestForm userData={auData.readAllApplicationUsers} queryData={data} requestItemData={riData} npData={npData.nextAndPreviousRequest} />
        </div>
      </div>
    );
  }
  return null
};
